
import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Typography,
    Grid2,IconButton, 
    TextField,
    Modal
} from "@mui/material";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import { useDispatch, useSelector } from 'react-redux';
import bestValue from "../.././../Assets/Images/bestValue.svg";
import accOpenLogo from "../../../Assets/Images/accOpn.png";
import PlansStyles from "./Products.module.css";
import navLogo from "../../../Assets/Images/logo.svg";
import applied from "../../../Assets/Images/applied.png";
import expIcon from "../../../Assets/Images/expertIcon.svg";
import wealthIcon from "../../../Assets/Images/wealthIcon.svg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as CryptoJS from "crypto-js";
import Swal from 'sweetalert2';
import { getPlanDetails, setEsignStatus, setPaymentStatus, setProductStatus, skipPaymentAndProceed } from "../../../Redux/usersSlice";
import collab from '../../../Assets/Images/collab1.svg';



export default function Products() {

  const { userData,planData,refCodeDataFromEmail,clientId,source } = useSelector(state => state.user);

  const [isEditing, setIsEditing] = useState(false);
  const [referralCode, setReferralCode] = useState(planData?.franchisee_code || "");


  const [accOpeningFee,setAccOpeningFee]=useState("")
  const [expertFee,setExpertFee]=useState("")
  const [wealthFee,setWealthFee]=useState("")
  // const [expertVisibility,setExpertVisibility]=useState("")
  // const [wealthVisibility,setWealthVisibility]=useState("")

  const [expertVisibility, setExpertVisibility] = useState(null)
  const [wealthVisibility, setWealthVisibility] = useState(null)

  const [invalidRefCodeErr,setInvalidRefCodeErr]=useState("")

  const [skipModal,setSkipModal]=useState(false)
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [paymentOrderId, setPaymentOrderId] = useState("");
  const [paymentTxId, setPaymentTxId] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
 const [paymentFailure, setPaymentFailure] = useState(false);

  


  
  console.log(planData.wealth_visibility  )
  console.log(planData.expert_visibility  )

  console.log("A",typeof accOpeningFee,accOpeningFee)
  console.log("B",planData.account_opening_fee)

   const baseHostName = window.location.hostname;
   let paymentUrl =""
  if(baseHostName.includes("staging") || baseHostName.includes("local")){
     paymentUrl="https://payment-gateway-staging.tradeboss.co"
  }else{
     paymentUrl="https://payment-gateway.tradeboss.co"
  }

  // Plan data structure
  // const PLANS = [
  //   {
  //     id: 'accountOpening',
  //     title: 'Account Opening Charge',
  //     icon: accOpenLogo,
  //     price: accOpeningFee || planData.account_opening_fee,
  //     required: true, // This plan is mandatory
  //     selected: true, // Always selected
  //     type: 'subscription',
  //     visible: true // Always visible
  //   },
  //   {
  //     id: 'expertAdvice',
  //     title: 'Expert Advice',
  //     icon: expIcon,
  //     price: expertFee || planData.expert_advice_fee,
  //     required: false,
  //     selected: false,
  //     type: 'expertRecommendation',
  //     bestValue: true,
  //     visible: expertVisibility || planData?.expertVisibility || false // Controlled by Redux state
  //   },
  //   {
  //     id: 'wealthVault',
  //     title: 'Wealth Vaults',
  //     icon: wealthIcon,
  //     price: wealthFee || planData.wealth_vault_fee,
  //     required: false,
  //     selected: false,
  //     type: 'wealthVault',
  //     visible: wealthVisibility || planData?.wealthVisibility || false // Controlled by Redux state
  //   }
  // ];

  // const visiblePlans = PLANS.filter(plan => plan.visible);

  // console.log("visible plans array",visiblePlans)

  const getPlans = () => [
  {
    id: 'accountOpening',
    title: 'Account Opening Charge',
    icon: accOpenLogo,
    price: (accOpeningFee !== "" ? accOpeningFee: planData?.account_opening_fee),
    required: true,
    selected: true,
    type: 'subscription',
    visible: true
  },
  {
    id: 'expertAdvice',
    title: 'Expert Advice',
    icon: expIcon,
    price: expertFee || planData.expert_advice_fee,
    required: false,
    selected: false,
    type: 'expertRecommendation',
    bestValue: true,
     visible: expertVisibility !== null ? expertVisibility : (planData?.expert_visibility || false)
  },
  {
    id: 'wealthVault',
    title: 'Wealth Vaults',
    icon: wealthIcon,
    price: wealthFee || planData.wealth_vault_fee,
    required: false,
    selected: false,
    type: 'wealthVault',
     visible: wealthVisibility !== null ? wealthVisibility : (planData?.wealth_visibility || false)
  }
];

const [plans, setPlans] = useState(getPlans().filter(plan => plan.visible));

function useDebounce(value, delay = 600) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
const debouncedReferralCode = useDebounce(referralCode, 600);
useEffect(() => {
  if (!isEditing) return;            // only when editing
  if (!debouncedReferralCode) {
    handleApplyRefCode("");          // clear case
    return;
  }

  handleApplyRefCode(debouncedReferralCode);

}, [debouncedReferralCode]);



  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [plans, setPlans] = useState(visiblePlans);
  const [loading, setLoading] = useState(false);

 const handleClose=()=>{
  setSkipModal(false)
  setReferralCode("")
  handleApplyRefCode("")
 }

  // Calculate total amount
  const totalAmount = plans.reduce((total, plan) => {
    return plan.selected ? total + plan.price : total;
  }, 0);

  // Add this useEffect to update plans when relevant states change
  useEffect(() => {
    setPlans(getPlans().filter(plan => plan.visible));
  }, [accOpeningFee, expertFee, wealthFee, expertVisibility, wealthVisibility, planData]);

  // Handle plan selection toggle
  const togglePlan = (planId) => {
    setPlans(prevPlans => 
      prevPlans.map(plan => 
        plan.id === planId && !plan.required 
          ? { ...plan, selected: !plan.selected } 
          : plan
      )
    );
  };

  // const handleSkip =()=>{
  //   //  if account opening fee is 0, if user want to skip
  //     dispatch(setProductStatus())
  // }

  const handleProceedSkipPayment =async(type)=>{
    if (type == "continue"){
      window.dataLayer.push({
        event: "kyc_step_viewed",
        step_name: "products_captured",
        page_path: window.location.pathname
      });
    }else if (type == "skip") {
      window.dataLayer.push({
        event: "kyc_step_viewed",
        step_name: "products_skipped",
        page_path: window.location.pathname
      });
    }
    console.log("STR")
    window.dataLayer = window.dataLayer || [];
        const response = await dispatch(
        skipPaymentAndProceed({
          email: userData.email.toLowerCase(),
          mobile: userData.mobile,
          referral_code: referralCode,
        })
      ).unwrap();

      if(response.data.data.message === "Payment status updated successfully"){
        navigate("/final-congrats");
        dispatch(setProductStatus())
        // dispatch(setEsignStatus())

      }

      console.log(response)

  }



  useEffect(() => {

    const params = new URLSearchParams(window.location.search);
    const encryptedData = params.get('data');
    if(!encryptedData){
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "kyc_step_viewed",
        step_name: "products_page_viewed",
        page_path: window.location.pathname
      });
    }
    
    const handleSkipPayment = async () => {
      if (planData.product_visibility === false) {
        dispatch(setProductStatus());
        dispatch(setEsignStatus())


        try {
          const response = await dispatch(
            skipPaymentAndProceed({
              email: userData.email.toLowerCase(),
              mobile: userData.mobile,
              referral_code: referralCode,
            })
          ).unwrap();

          if (response.data?.data?.message === "Payment status updated successfully") {
            navigate("/final-congrats");
          }
        } catch (error) {
          console.error("Error skipping payment:", error);
        }
      }
    };

    handleSkipPayment();
  }, []);


  console.log(planData)

  const handleNavigateFinal=()=>{
 navigate("/final-congrats");
 
        dispatch(setPaymentStatus());
        // dispatch(setEsignStatus())
  }

  // Payment status check from URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const encryptedData = params.get('data');
    
    if (!encryptedData) return;

    const baseUrl = window.location.origin + window.location.pathname;
    // window.history.replaceState({}, document.title, baseUrl);

    try {
      const decoded = decodeURIComponent(encryptedData);
      const decrypted = CryptoJS.AES.decrypt(decoded, "96358214256984120").toString(CryptoJS.enc.Utf8);

      if (!decrypted) {
        console.error("Decryption failed or returned empty string");
        return;
      }

      const parsedData = JSON.parse(decrypted);
      console.log("Parsed Decrypted Data:", parsedData);

      if (parsedData?.order_status === "Success") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "kyc_step_viewed",
          step_name: "products_captured",
          page_path: window.location.pathname
        });
        setPaymentSuccess(true)
        setPaymentOrderId(parsedData?.orderid);
        setPaymentTxId(parsedData?.tracking_id)
        setPaymentAmount(parsedData?.amount);
       
      }

      if (parsedData?.order_status === "Failed") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "kyc_step_viewed",
          step_name: "products_captured",
          page_path: window.location.pathname
        });
        // Swal.fire({
        //   title: "Payment Failed!",
        //   html: `<i class="fas fa-info-circle custom-icon"></i> 
        //          <p>Unfortunately your payment failed. Please try again</p><br>`,
        //   confirmButtonText: "Ok",
        //   confirmButtonColor: "#f3d45e",
        //   background: "#f8f9fa",
        //   color: "#333",
        //   customClass: {
        //     confirmButton: PlansStyles.customConfirmButton,
        //   },
        // });
        //  setPaymentSuccess(false)
        setPaymentFailure(true)
        setPaymentOrderId(parsedData?.orderid);
        setPaymentTxId(parsedData?.tracking_id)
        setPaymentAmount(parsedData?.amount);
      }
    } catch (err) {
      console.error("Error during decryption or parsing:", err);
    }
  }, [dispatch, navigate]);

  // Redirect if payment already done
  useEffect(() => {
    const isPaymentNotPresent = !("Subscription Plan" in (userData?.steps || {}))
    const isPaymentDone = userData?.steps?.["Subscription Plan"]?.status;
    // const isEsignDone = userData?.steps?.["Esign"]?.status;
    // const isFinalDone = userData?.steps?.["Congrats Page"]?.status;
     console.log("isPaymentNotPresent",isPaymentNotPresent,"isPaymentDone",isPaymentDone)
    if (isPaymentDone || isPaymentNotPresent) {
      // if (isPaymentDone && isEsignDone) {
      //   navigate("/final-congrats");
      // } else {
      //   navigate("/final-congrats");
      // }
      navigate("/final-congrats")
    }
  }, [userData, navigate]);

  // Dynamic payment handler
  const handlePayment = async () => {
    // setLoading(true);
    
    // Create payload based on selected plans
    const selectedPlans = plans.filter(plan => plan.selected);
    
    const payload = {
      plan: {
        subscription: {
          subscribed: selectedPlans.some(p => p.type === 'subscription'),
          amount: selectedPlans.find(p => p.type === 'subscription')?.price.toString() || "0"
        },
        expertRecommendation: {
          subscribed: selectedPlans.some(p => p.type === 'expertRecommendation'),
          amount: selectedPlans.find(p => p.type === 'expertRecommendation')?.price.toString() || "0"
        },
        wealthVault: {
          subscribed: selectedPlans.some(p => p.type === 'wealthVault'),
          amount: selectedPlans.find(p => p.type === 'wealthVault')?.price.toString() || "0"
        },
      },
      mobileno: userData.mobile,
      emailid: userData.email.toLowerCase(),
      pushtype: 1,
      amount: (parseInt(totalAmount) + totalAmount * 0.18).toFixed(2),
      // clientid: "AAA367",
       source: "signup_web",
    };
    const notesPayload = {
      source: "signup_web",
      plans: selectedPlans.map(plan => plan.id).join(","),
      clientid: clientId || userData?.client_id,
    };

    console.log(payload)
    console.log(notesPayload)

    try {
      const payment = await axios.post(paymentUrl+"/api/razorpay/payorder", payload);
      console.log(payment, "payment");
      
      if (payment.status === 200) {
        let callback_url = paymentUrl+"/api/razorpay/paystatus?orderId=" + payment.data.data.orderid;
        let mobilenum = `+91${userData.mobile}`;
        
        const options = {
          key: payment.data.data.orderkey,
          amount: totalAmount * 100, // Razorpay expects amount in paise
          currency: "INR",
          name: "Tradeboss",
          description: `Selected plans: ${selectedPlans.map(p => p.title).join(", ")}`,
          order_id: payment.data.data.orderid,
          redirect: true,
          callback_url: callback_url,
          notes: notesPayload,
          method: {
            netbanking: true,
            card: false,
            wallet: false,
            upi: true
          },
          prefill: {
            email: payload.emailid,
            contact: mobilenum,
          },
          modal: {
            ondismiss: function() {
              setLoading(false);
            }
          }
        };
        
        const paymentObject = new window.Razorpay(options);
        paymentObject.on('payment.failed', function(response) {
          setLoading(false);
        });
        paymentObject.open();
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      Swal.fire({
        title: "Error!",
        text: "An error occurred while processing your payment. Please try again.",
        icon: "error",
        confirmButtonColor: "#f3d45e",
      });
    }
  };

  const handleApplyRefCode = async (value) => {
    try {
      console.log("handle apply",value);

      const response = await dispatch(
        getPlanDetails({
          email: userData.email.toLowerCase(),
          mobile: userData.mobile,
          referral_code: value,
        })
      ).unwrap();

      console.log("Plan details response:", response.data.data );
      // console.log("response.data.data.account_opening_fee",response.data.data.plan.account_opening_fee)
  
      if(response.data.data.message === "Invalid Referral code"){
             setIsEditing(true)
             setInvalidRefCodeErr("Invalid Referral code")
      }else if(response.data.data.plan.product_visibility === false){
        setSkipModal(true)
      setInvalidRefCodeErr("")

      }
      
      else{
      setAccOpeningFee(response.data.data.plan.account_opening_fee)
      setExpertFee(response.data.data.plan.expert_advice_fee)
      setWealthFee(response.data.data.plan.wealth_vault_fee)
      // setExpertVisibility(response.data.data.plan.expertVisibility)
      // setWealthVisibility(response.data.data.plan.wealthVisibility)
       // Explicitly set boolean values here
      setExpertVisibility(response.data.data.plan.expert_visibility === true)
      setWealthVisibility(response.data.data.plan.wealth_visibility === true);
      setIsEditing(false)
      setInvalidRefCodeErr("")
      }

    } catch (err) {
      console.error("Failed to apply referral code:", err);
    }
  };

  return (
    <>
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center !important",
        alignItems: "center !important",
        minHeight: "100vh !important",
        backgroundImage: `url(${SignUpBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}>
        {/* Logo Section */}
        <Box
          sx={{
            margin: "0px 10px 0px 0px",
            display: "flex",
            justifyContent: "center",
            flexDirection:"column",
            alignItems: "center !important",
            "@media (max-width:1000px)": {
              marginLeft: "0px !important",
            },
            "@media (max-width:500px)": {
              marginTop: "0px !important",
            },
            "@media (max-height:735px)": {
              marginTop: "25px !important",
            }
          }}
        >
       <Box
        component="img"
        src={source == "cosmos" ? collab : navLogo}
        alt="Logo"
            className={source == "cosmos" ? PlansStyles.twologo : PlansStyles.logo}
      />
          {
            source == "cosmos" &&
            <Typography className={PlansStyles.txt1}>
              Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
            </Typography>
          }
        </Box>

        {/* Plans Section */}
        <Grid2 className={PlansStyles.content_wrapper}>
          <Typography className={PlansStyles.heading}>Our Products</Typography>
          <Grid2 className={PlansStyles.inner}>
            {/* Mandatory Account Opening Card */}
            <Grid2 
              className={`${PlansStyles.card1} ${PlansStyles.mandatory}`}
              onClick={() => {}}
            >
              <Grid2 className={PlansStyles.img_card1}>
                <img src={accOpenLogo} alt="logo" className={PlansStyles.acc_logo} />
              </Grid2>
              <Typography className={PlansStyles.accsub_title1}>
                Account Opening Charge
              </Typography>
              {/* <span className={PlansStyles.symbol}>₹</span> */}
              <Typography className={PlansStyles.accsub_title2}>₹{accOpeningFee !== "" ? accOpeningFee: planData?.account_opening_fee}</Typography>
            
            </Grid2>

            {/* <Grid2 className={PlansStyles.refer_card}>
  <Grid2 className={PlansStyles.refer_inner_card}>
    <Typography sx={{ fontSize: "13px !important" }}>
      Referral code
    </Typography>

    {isEditing ? (
      <TextField
        value={referralCode}
        onChange={(e) => setReferralCode(e.target.value.toUpperCase())}
        size="small"
        variant="standard"
        sx={{ paddingLeft: "25px !important" }}
        InputProps={{ disableUnderline: true }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleApplyRefCode();
          }
        }}
      />
    ) : (
      <Typography className={PlansStyles.refer_code}>
        {referralCode}
      </Typography>
    )}

    {!isEditing && referralCode && (
      <>
        <Typography className={PlansStyles.applied}>applied</Typography>
        <img
          src={applied}
          alt="logo"
          className={PlansStyles.applied_icon}
        />
      </>
    )}

    <IconButton className={PlansStyles.refer_remove}>
      {isEditing ? (
        <Typography
          onClick={handleApplyRefCode}
          sx={{ fontFamily: "Inter500 !important" }}
        >
          Apply
        </Typography>
      ) : (
        <Typography
          onClick={() => setIsEditing(true)}
          sx={{ fontFamily: "Inter500 !important" }}
        >
          {referralCode ? "Edit" : "Add"}
        </Typography>
      )}
    </IconButton>
  </Grid2>
</Grid2> */}

            {/* <Grid2 className={PlansStyles.refer_card}>
              <Grid2 className={PlansStyles.refer_inner_card}>
                <Typography sx={{ fontSize: "13px !important" }}>
                  Referral code
                </Typography>

                {isEditing ? (
                  <TextField
                    value={referralCode}
                    onChange={(e) => setReferralCode(e.target.value.toUpperCase())}
                    size="small"
                    variant="standard"
                    sx={{ paddingLeft: "25px !important" }}
                    InputProps={{ disableUnderline: true }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleApplyRefCode();
                      }
                    }}
                  />
                ) : (
                  <Typography className={PlansStyles.refer_code}>
                    {referralCode}
                  </Typography>
                )}

                {!isEditing && referralCode && (
                  <>
                    <Typography className={PlansStyles.applied}>applied</Typography>
                    <img
                      src={applied}
                      alt="logo"
                      className={PlansStyles.applied_icon}
                    />
                  </>
                )}

                <IconButton className={PlansStyles.refer_remove}>
                  {isEditing ? (
                    <Typography
                      onClick={handleApplyRefCode}
                      sx={{ fontFamily: "Inter500 !important" }}
                    >
                      Apply
                    </Typography>
                  ) : (
                    <Typography
                      onClick={() => setIsEditing(true)}
                      sx={{ fontFamily: "Inter500 !important" }}
                    >
                      {referralCode ? "Edit" : "Add"}
                    </Typography>
                  )}
                </IconButton>
              </Grid2>
            </Grid2> */}

            <Grid2 className={PlansStyles.refer_card}>
              <Grid2 className={PlansStyles.refer_inner_card}>
                <Typography sx={{ fontSize: "13px !important" }}>
                  Referral code
                </Typography>

                {isEditing ? (
                  <TextField
                    value={referralCode}
                    // onChange={(e) => {
                    //   const value = e.target.value.toUpperCase().trim();
                    //   setReferralCode(value);

                    //   if (value.length === 3 || value.length===0) {
                    //     handleApplyRefCode(value);     // call when length = 3
                    //     setIsEditing(false);      // optionally exit edit mode
                    //   }
                    // }}
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase().trim();
                      setReferralCode(value);
                      setIsEditing(true);
                    }}

                    size="small"
                    variant="standard"
                    sx={{ paddingLeft: "25px !important" }}
                    InputProps={{ disableUnderline: true }}
                    autoFocus
                  />
                ) : (
                  <Typography
                    className={PlansStyles.refer_code}
                    onClick={() => setIsEditing(true)}
                    style={{ cursor: "pointer" }}
                  >
                    {referralCode || "Add"}
                  </Typography>
                )}

                {!isEditing && referralCode && (
                  <>
                    <Typography className={PlansStyles.applied}>applied</Typography>
                    <img
                      src={applied}
                      alt="logo"
                      className={PlansStyles.applied_icon}
                    />
                  </>
                )}
              </Grid2>
            </Grid2>



            <br></br>

          </Grid2>
          {!referralCode && (
            <Typography
              variant="body2"
              sx={{
                margin: "10px !important",
                fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" }, // responsive font sizes
              }}
            >
              No Referral code applied
            </Typography>
          )}

          {invalidRefCodeErr && (
            <Typography
              variant="body2"
              sx={{
                color: "red",
                margin: "5px !important",
                fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" }, // responsive font sizes
              }}
            >
              {invalidRefCodeErr}
            </Typography>
          )}
          <div className={PlansStyles.horizontal_line}></div>
        </Grid2>

        {/* Optional Plans Section */}
        <Grid2 className={PlansStyles.inner_card}>
          <Grid2 className={PlansStyles.inner_card1}>
            {plans.filter(plan => !plan.required).map((plan) => (
              <Grid2 
                key={plan.id}
                className={`${PlansStyles.card3} ${plan.selected ? PlansStyles.selectedCard : ''}`}
                onClick={() => togglePlan(plan.id)}
                sx={{cursor:"pointer !important",
                  border:plan.selected && "3px solid #f3d45e !important"
                }}
              >
                {plan.bestValue && (
                  <img src={bestValue} className={PlansStyles.bestValue} alt="Best Value" />
                )}
                <Grid2 className={PlansStyles.subcard1}></Grid2>

                <Grid2 sx={{ 
                  padding: "28px 0px 0px 20px", 
                  display: "flex", 
                  flexDirection: "row",
                  "@media (max-width:680px)": {
                    paddingTop: "25px",
                  },
                }}>
                  <Grid2 className={PlansStyles.img_card2}>
                    <img src={plan.icon} alt={plan.title} />
                  </Grid2>
                  <Typography className={PlansStyles.plan_title}>
                    {plan.title}
                  </Typography>
                </Grid2>
                <Grid2 sx={{
                  padding: "0px 0px 0px 69px",
                  display: "flex",
                  flexDirection: "row",
                  "@media (max-width:680px)": {
                    paddingLeft: "64px",
                  },
                }}>
                  <Typography className={PlansStyles.symbol1}>₹</Typography>
                  <Typography className={PlansStyles.zero_amt}>
                    {plan.price}/year
                  </Typography>
                </Grid2>
                {plan.selected && (
                  <img
                    src={applied}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '6px',
                      zIndex: 2,
                    
                      height: '20px',
                      width: '20px'

                    }}
                    alt="Selected"
                  />
                )}
              </Grid2>
            ))}
          </Grid2>
          
          {/* Price Details Section */}
          <Typography className={PlansStyles.price_dtl}>
            Price Details
          </Typography>

          {plans.filter(plan => plan.selected).map(plan => (
            <Grid2 key={`price-${plan.id}`} className={PlansStyles.price_card}>
              <Typography className={PlansStyles.label}>
                {plan.title}
              </Typography>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography className={PlansStyles.symb4}>₹</Typography>
                <Typography className={PlansStyles.amt4}>{plan.price}</Typography>
              </div>
            </Grid2>

          ))}

          <div className={PlansStyles.horizontal_line1}></div>

          <Grid2 className={PlansStyles.price_card}>
            <Typography className={PlansStyles.label1}>
              Total payable amount
            </Typography>
           
            <Typography className={PlansStyles.amt4}>
              ₹{totalAmount}
            </Typography>
          </Grid2>

          {totalAmount>0 && <Grid2 className={PlansStyles.but_card}>
            <Button 
              className={PlansStyles.but} 
              onClick={handlePayment}
              disabled={loading}
            >
              {loading ? 'Processing...' : `Pay ₹${totalAmount}`}
            </Button>
            
          </Grid2>}
          {!(totalAmount>0) && <Grid2 className={PlansStyles.but_card1}>
            <Button
              className={PlansStyles.skip_button}
              onClick={()=>{handleProceedSkipPayment("continue")}}
              disabled={loading}
            >
              Continue
            </Button>

          </Grid2>}
        </Grid2>
      </Box>
      <Modal open={skipModal} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            p: 4,
            borderRadius: 2,
            boxShadow: 24,
            minWidth: 300,
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
           Referral Code - {referralCode} 
          </Typography>
          <Typography>This Particular referral code will skip the payment page and redirect to final page <br></br>
            Do you want to proceed
          </Typography>
          <Button onClick={handleClose} sx={{ mt: 2, mr:2 }} variant="outlined">
            cancel
          </Button>
           <Button onClick={()=>{handleProceedSkipPayment("skip")}} sx={{ mt: 2 }} variant="contained" >
            proceed
          </Button>
        </Box>
      </Modal>

      <Modal open={paymentSuccess} sx={{ border: "none" }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            height: "auto",
            outline: "none",
            background: "#ffffff",
            p: 4,
            borderRadius: "8px",
            padding: "2%",
            justifyContent: "center",
            alignItems: "center",
            "@media only screen and (max-width: 800px)": {
              width: "80% !important",
            },
            "@media only screen and (max-width: 500px)": {
              paddingTop: "20px !important",
              paddingBottom: "20px !important",
              width: "90% !important",
            },
          }}
        >
          <Grid2
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            {/* <img src={successIcon} alt={successIcon} width="80"></img> */}
          </Grid2>
          <Grid2
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              gap: "10px",
              marginTop: "10px",
              padding: "0px 20px",
            }}
          >
            <Typography className={PlansStyles.payment_succ}>
              Payment Successful
            </Typography>
            <Typography className={PlansStyles.payment_msg}>
              Order No: {paymentOrderId}
            </Typography>
            <Typography className={PlansStyles.payment_msg}>
              Transaction No: {paymentTxId}
            </Typography>
            <Grid2
              style={{ width: "100%", borderBottom: "1px solid #D9D9D9" }}
            ></Grid2>
            <Typography className={PlansStyles.payment_msg}>
              Amount: ₹ {paymentAmount}
            </Typography>
            <Button
              className={PlansStyles.paymentSuccessButton}
              onClick={handleNavigateFinal}
              // disabled={loader}
            >
              Ok
            </Button>
          </Grid2>
        </Box>
      </Modal>
      <Modal
        open={paymentFailure}
        disableBackdropClick={true}
        onClose={() => setPaymentFailure(false)}
        sx={{ border: "none", zIndex: 1300 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            height: "auto",

            outline: "none",
            background: "#ffffff",
            p: 4,
            borderRadius: "8px",
            padding: "2%",
            justifyContent: "center",
            alignItems: "center",
            "@media only screen and (max-width: 800px)": {
              width: "80% !important",
            },
            "@media only screen and (max-width: 500px)": {
              paddingTop: "20px !important",
              paddingBottom: "20px !important",
              width: "90% !important",
            },
          }}
        >
          <Grid2
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            {/* <img src={errorIcon} alt="errorIcon" width="70"></img> */}
          </Grid2>
          <Grid2
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              gap: "10px",
              marginTop: "10px",
              padding: "0px 20px",
            }}
          >
            <Typography className={PlansStyles.payment_succ}>
              Payment Failed
            </Typography>
            {/* {paymentErrorMessage && (
              <Typography className={styles.payment_msg}>
                Message: {paymentErrorMessage}
              </Typography>
            )} */}
            {paymentOrderId && (
              <Typography className={PlansStyles.payment_msg}>
                Order No: {paymentOrderId}
              </Typography>
            )}
            {paymentTxId && (
              <Typography className={PlansStyles.payment_msg}>
                Transaction No: {paymentTxId}
              </Typography>
            )}
            <Grid2
              style={{ width: "100%", borderBottom: "1px solid #D9D9D9" }}
            ></Grid2>
            <Typography className={PlansStyles.payment_msg}>
              Amount: ₹ {paymentAmount}
            </Typography>
            <Button onClick={() => { setPaymentFailure(false) }} className={PlansStyles.paymentSuccessButton} >Try Again</Button>
          </Grid2>
        </Box>
      </Modal>
    </>
  );
}
